import React, {Fragment, useEffect} from "react";
import {ModalError} from "views/components/modals/error/modal_error.component";
import {ModalAccountUpdated} from "views/components/modals/account/account_updated.component";
import {SavedModal} from "views/components/modals/saved_modal/saved_modal.component";
import {LosePicks} from "views/components/modals/lose_picks_modal/lose_picks_modal.component";
import {UncompleteModal} from "views/components/modals/uncomplete_step_modal/uncomplete_modal.component";
import {SkipModal} from "views/components/modals/skip_modal/skip_modal.component";
import {ModalShare} from "views/components/modals/share_modal/modal_share.component";
import {WelcomeModal} from "views/components/modals/welcome_modal/welcome_modal.component";
import {useViewController} from "data/services/locator";
import {IGlobalModalsController} from "views/components/modals/global_modals.controller";
import {Bindings} from "data/constants/bindings";
import {ISessionController} from "views/components/session/session.controller";
import {observer} from "mobx-react";
import {useLocation} from "react-router-dom";
import {NewPickModal} from "views/components/modals/new_pick_modal/new_pick_modal.components";

export const Modals: React.FC = observer(() => {
	const {isSessionChecked} = useViewController<ISessionController>(Bindings.SessionController);
	const location = useLocation();

	const {setIsSessionChecked, onLocationChange} = useViewController<IGlobalModalsController>(
		Bindings.GlobalModalsController,
		{isSessionChecked, location}
	);

	useEffect(() => {
		setIsSessionChecked(isSessionChecked);
	}, [isSessionChecked, setIsSessionChecked]);

	useEffect(() => {
		onLocationChange(location);
	}, [location, onLocationChange]);

	return (
		<Fragment>
			<ModalError />
			<ModalAccountUpdated />
			<SavedModal />
			<LosePicks />
			<UncompleteModal />
			<SkipModal />
			<ModalShare />
			<WelcomeModal />
			<NewPickModal />
		</Fragment>
	);
});
